<template>
  <div class="container-fluid __windowHeight_">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-sm p-0">
          <div class="promo_page">
            <div class="container-fluid p-0 __100vh_">
              <div class="row justify-content-between __pathlist2_ pl-0 __wrapper_">
                <p class="__path">Promo</p>
              </div>
              <div class="__mastercontent">
                  <keep-alive>
                      <PromoList></PromoList>
                  </keep-alive>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import PromoList from '@/components/promo/PromoList'

export default {
  name: 'Promo',
  components: {
    Sidebar,
    PromoList
  }
}
</script>



// WEBPACK FOOTER //
// src/view/promo/index.vue